import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginPageComponent } from './pages/login-page/login-page.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { MainPageComponent } from './pages/main-page/main-page.component';
import { kmTokenInterceptor } from './http-interceptors/http-interceptor';
import { GridModule } from '@progress/kendo-angular-grid';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
//import { UtilsModule } from '@progress/kendo-angular-utils';
import { MasterDataEditorComponent } from './components/master-data/master-data-editor/master-data-editor.component';
import { SimpleNotificationsModule } from 'angular2-notifications';
import { IndicatorsModule } from '@progress/kendo-angular-indicators';
import { UserListComponent } from './components/users/user-list/user-list.component';
import { ManageUserPageComponent } from './pages/manage/users/manage-user-page/manage-user-page.component';
import { UserDetailComponent } from './components/users/user-detail/user-detail.component';
import { DialogsModule } from '@progress/kendo-angular-dialog';
import { MasterDataPageComponent } from './pages/manage/master-data/master-data-page/master-data-page.component';
import { ChartsModule } from '@progress/kendo-angular-charts';
import { OpenConnectionsPageComponent } from './pages/manage/open-connections/open-connections-page/open-connections-page.component';

//import { NotificationService } from '@progress/kendo-angular-notification';
//import { NotificationModule } from '@progress/kendo-angular-notification';

@NgModule({ declarations: [
        AppComponent,
        LoginPageComponent,
        MainPageComponent,
        MasterDataEditorComponent,
        UserListComponent,
        ManageUserPageComponent,
        UserDetailComponent,
        MasterDataPageComponent,
        OpenConnectionsPageComponent,
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        AppRoutingModule,
        FormsModule,
        NgbModule,
        GridModule,
        BrowserAnimationsModule,
        SimpleNotificationsModule.forRoot(),
        IndicatorsModule,
        ChartsModule,
        DialogsModule
        //UtilsModule,
        //NotificationModule,
    ], providers: [provideHttpClient(withInterceptors([kmTokenInterceptor]))] })
export class AppModule { }
